export const ERROR_MESSAGES = {
  paymentRefunded: 'Payment has already been refunded'
};

export const handleErrorMessage = (e) => {
  const message = e.data?.message || e.message || e.data?.name || e;
  if (message.includes('been refunded') && e.data.type === 'StripeInvalidRequestError') {
    return ERROR_MESSAGES.paymentRefunded;
  }

  return message;
};
